import request from '@/utils/request'

//展示列表
export function plateList(data) {
	return request({
		url: '/forum/tForumPlateDO/getPaper',
		method: 'get',
		params: data
	})
}
//根据id查找列表
export function plateByid(data) {
	return request({
		url: '/forum/tForumPlateDO',
		method: 'get',
		params: data
	})
}
// 添加
export function addPlate(data) {
	return request({
		url: '/forum/tForumPlateDO',
		method: 'post',
		data
	})
}
// 编辑
export function updatePlate(data) {
	return request({
		url: '/forum/tForumPlateDO',
		method: 'put',
		data
	})
}
// 删除
export function deletePlate(data) {
	return request({
		url: '/forum/tForumPlateDO',
		method: 'delete',
		params: data
	})
}